import React, { Component } from "react";
import InputForm from "./InputForm";
import axios from "axios";
import { maskCPF, maskCNPJ, limparCpfCnpj } from '../utils/Masker';


class PessoaFrame extends Component {
    state = {
        lista: [],
        codigo: {
            key: '0',
            label: '',
        },
        buscando: false,
    }

    componentDidUpdate(propsAnterior, stateAnterior) {
        if (this.state.codigo.key !== this.props.value.key) {
            this.setState({
                codigo: {
                    key: this.props.value.key,
                    label: this.props.value.label,
                },
                lista: [
                    { key: '0', label: 'Todos os Clientes', },
                    { key: this.props.value.key, label: this.props.value.label, }
                ]
            })
        }
    }

    componentDidMount() {
        // this.getListaRegistros();
    }


    formatarCpfCnpj = (cpfCnpj) => {
        const value = limparCpfCnpj(cpfCnpj);

        if (!value) return '';

        return /^[0-9]{11}$/.test(value)
            ? maskCPF(value)
            : maskCNPJ(value);
    }

    getListaRegistros = (value) => {
        this.setState({ lista: [] })

        clearTimeout(this.buscaRegistrosId);
        this.buscaRegistrosId = setTimeout(() => {
            if (value.length >= 3) {
                this.setState({ buscando: true });

                axios.get('/pessoas/listaBusca', {
                    params: {
                        nome: value
                    }
                }).then(response => {
                    const { data } = response;
                    const lista = data.map(regList => {
                        const cpfCnpj = this.formatarCpfCnpj(regList.pes_cpf_cnpj);
                        return {
                            key: regList.pes_idf,
                            label: regList.pes_nome + ' [' + regList.pes_codigo + '] ' + (cpfCnpj ? ' [' + cpfCnpj + '] ' : ''),
                        }
                    });
                    this.setState({
                        lista,
                        buscando: false,
                    })
                }).catch(error => {
                    console.error(error.response);
                    this.setState({
                        lista: [],
                        buscando: false,
                    })
                })
            }
        }, 1000);
    };

    onChange = event => {
        const value = event.target.value;
        const id = event.target.id;
        this.setState({
            [id]: value,
            codigo: value,
        });
        const state = {};
        state[id] = value;
        this.props.onChange(state);
    };



    render() {
        const { label, id, width, disabled } = this.props;
        const { lista, codigo, buscando } = this.state;

        // console.log('PessoaFrame: ', this.state);

        return (
            <span style={{}}>
                <span>{label}</span>
                <InputForm
                    type="select"
                    id={id}
                    ref={id}
                    value={codigo}
                    onChange={this.onChange}
                    data={lista}
                    validator={value => Boolean(value)}
                    onSearch={this.getListaRegistros}
                    fetching={buscando}
                    showArrow={false}
                    filterOption={false}
                    notFoundContent={null}
                    defaultActiveFirstOption={false}
                    showSearch
                    style={{ width: width }}
                    disabled={disabled ? true : false}
                />
            </span>
        );
    }
}

export default PessoaFrame;



// WEBPACK FOOTER //
// ./src/components/PessoaFrame.js